export const costs = [
  'Sleepless nights translating complex chemistry and engineering concepts',
  'Improvised explanations from disorganized technical materials',
  "Disconnected colleagues who don't see chemical process relevance",
  'Weekends building technical references and process analyses from scratch',
  'No clear answers when professionals ask technical questions',
];
